import { environment } from './../environments/environment';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { ScriptLoaderService } from "./common/services/script.loader.service";
import { SharedService } from './common/services/shared.service';
import { CommonConstant } from './common/utilities/common-constant';
import { digitalData, initiPageInfo, _satellite } from './common/services/adobe-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { RouteHandlerService } from './common/services/route-handler.service';
import { StorageHandlerService } from './common/services/storage-handler.service';

const SCRIPT_PATH = environment.serviceBaseUrls.FinSDKURL;
declare let finvuClient: any;

window['digitalData'] = digitalData;
window['_satellite'] = _satellite;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  finvuData: any;
  title = 'om-credit-webuifldgunsecuredservice';
  hostName = window.location?.hostname;
  public productId: any;
  public selectedBanks: any[] = [];
  constructor(public routeHandler: RouteHandlerService,public scriptLoaderService: ScriptLoaderService,
    public sharedService: SharedService,
    public renderer: Renderer2,
    public spinnerService: NgxSpinnerService,) {
  }

  ngOnInit() {
    this.getIframeData();
    this.getQueryParams();
    this.productId = StorageHandlerService.get('productid') || StorageHandlerService.get('occupationIdentifier');
    this.selectedBanks =  this.sharedService.selectedBankDetails();
  }

  // temporirly disable
  ngAfterViewInit(): void {
    // this.addExteranlScript(environment.mouseFlowScript);
    setTimeout(() => {
      this.addExteranlScript(environment.adobeAnalytics);
    }, 0);
  }

  getIframeData(){
    window.addEventListener("message", ((res) => {
      let result = res.data;
      if (res.data.finvuconsentid && StorageHandlerService.get('finvuconsentid') !==(null || undefined || '' || 'undefined' || 'null')) {
        const keys = CommonConstant.setFinvuStorageKeys;
        Object.keys(keys).forEach(ele => {
          const val = result[ele];
          if(val && val.trim() !== (null || undefined || '' || 'undefined' || 'null')){
            StorageHandlerService.set(keys[ele],result[ele]);
          }   
        });
        setTimeout(() => {
          this.loadClientScript();
        }, 500);
      }
      else{
         window.removeEventListener("message", (() => {console.log('inside remove listener') }));
      }

    }), true)
}

  private addExteranlScript(scriptUrl) {
    console.log('addExteranlScript');
    const script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('type', 'text/javascript');
    let applicationKey = StorageHandlerService.get('applicationid');
    script.addEventListener('load', () => { initiPageInfo('Loan', 'Account Aggregator', 'open arch:loan', this.productId, 'Account Aggregator', '', applicationKey,'','','','','','',this.selectedBanks); });
    script.defer = true;
    document.body.appendChild(script);
  }
  // func to load script
  loadClientScript() {
    this.spinnerService.show();
    const scriptElement = this.scriptLoaderService.loadJsScript(this.renderer, SCRIPT_PATH);
    scriptElement.onload = () => {
      console.log('Finvu SDK Script loaded');
       finvuClient.open().then(res=>{
        this.spinnerService.hide();
        this.sharedService.setData(CommonConstant.DataSharingKeys.FINVUCLIENT, finvuClient);
        this.decideRoute();
       }, error=>{
        console.log("Finvu=====error",error);
       });
       
    }
    scriptElement.onerror = () => {
      console.log('Could not load the Finvu SDK Script!');
    }
  }

  public decideRoute() {
    let getUTMs = {
      ...this.getQueryParams()
    }
    this.routeHandler.NavigateToViewWithQueryParams([CommonConstant.Routes.Login],getUTMs);
  }

  private getQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const params: any = {};
    urlParams.forEach((value, key) => {
      sessionStorage.setItem(key, value);
      params[key] = value;
    });
    return params;
  }
}
